/* eslint-disable no-script-url */
import React from 'react';
import {
  getEncTicket,
  getEndDate,
  getGraceFormattedTime,
  getPreExpiryFormattedTime,
} from 'utils/primeUtil';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import { gaWrapper } from 'helpers/analytics';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import PropTypes from 'prop-types';
import {
  PRC_FOR_FTU,
  PRC_FOR_FT_EXPIRED,
  PRC_FOR_SUBSCRIBED,
  PRC_FOR_SUBSCRIPTION_EXPIRED,
  PRC_FOR_SUBSCRIPTION_CANCELLED,
  ET_DOMAIN_WEB,
  MY_SUBSCRIPTION_PAGE_URL,
  REDEEM_BENEFITS_PAGE_URL,
} from 'constants/index';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Cookie from '../../utils/cookies';

class LoggedInUser extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      rewardsData: {},
      primeEndDate: '',
      showEpaperDropDown: false,
      graceDate: '',
      daysRemaining: '',
    };
  }

  componentDidMount() {
    const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    if (!ssoid) {
      return;
    }

    makeRequest
      .get(
        `https://rewards.indiatimes.com/bp/api/urs/ups?format=json&pcode=TOI&uid=${ssoid}`,
        {},
        'skipfeedengine',
      )
      .then(data => {
        if (
          data &&
          data.status === 200 &&
          data.data &&
          data.data.output &&
          typeof data.data.output.user === 'object'
        ) {
          this.setState({ rewardsData: data.data.output.user });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userPrcData !== this.props.userPrcData) {
      if (
        this.props.isPrimeUser ||
        (this.props.userData &&
          [
            PRC_FOR_FTU,
            PRC_FOR_FT_EXPIRED,
            PRC_FOR_SUBSCRIBED,
            PRC_FOR_SUBSCRIPTION_EXPIRED,
            PRC_FOR_SUBSCRIPTION_CANCELLED,
          ].indexOf(this.props.userData.prcValue) > -1)
      ) {
        getEndDate(this.props.userPrcData).then(res => {
          const primeEndDate = new Date(res).toDateString().replace(' ', ', ');
          this.setState({
            primeEndDate,
          });
        });
        getPreExpiryFormattedTime(this.props.userPrcData).then(res => {
          this.setState({
            daysRemaining: res,
          });
        });
        getGraceFormattedTime(this.props.userPrcData).then(res => {
          this.setState({
            graceDate: res,
          });
        });
      }
    }
  }

  startPrimeRenewal = () => {
    const utmsFinal = {
      utm_source: 'TOI',
      utm_medium: 'Renew_Now_Nudge',
    };

    utmsFinal.utm_campaign = 'Referral_Web_TOI';
    // primePaymentflowStartEmitter({
    //   formType: 'paymentScreen',
    //   stop_redirection_for_subscribed: false,
    //   callback: () => {},
    //   utmsFinal,
    // });
    // toiSubscriptionflowStartEmitter({
    //   screenType: 'planScreen',
    // });
    gaWrapper('send', 'event', window.categoryForGA, 'Renew_Now', ``);
    getEncTicket(false).then(data => {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData(
          this.props.unifiedNodes[`prc${this.props.userData.prcValue}`],
          data,
        ),
      );
    });
  };

  onLogoutClick = () => {
    this.props.logout();
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.removeItem('inGracePeriod');
      sessionStorage.removeItem('displayRenewNudge');
    }
  };

  clickHandler = (e, val) => {
    e.preventDefault();
    let { city } = val;
    if (
      typeof localStorage === 'object' &&
      typeof localStorage.getItem === 'function'
    ) {
      const prefInSession = JSON.parse(
        localStorage.getItem('epaper_preferences'),
      );
      if (prefInSession && prefInSession[val.seoName]) {
        city = prefInSession[val.seoName].city;
      }
    }
    const newURL = `https://epaper.indiatimes.com/timesepaper/publication-${
      val.seoName
    },city-${city}.cms`;
    window.location.href = newURL;
  };

  fireRedeemBenefitsGA4 = () => {
    if (!window.redeemGA4Fired) {
      analyticsWrapper('ga4', {
        event: 'redeem_benefits',
        steps_name: 'view',
      });
      window.redeemGA4Fired = true;
    }
  };

  render() {
    const { rewardsData, primeEndDate } = this.state;
    const {
      isPrimeUser,
      userData,
      toipLayout,
      inGracePeriod,
      isPreExpired,
      userIdentity,
    } = this.props;
    const isSubscribed =
      userData &&
      (userData.prcValue === PRC_FOR_FTU ||
        userData.prcValue === PRC_FOR_SUBSCRIBED);
    const isSubsExpired =
      userData &&
      (userData.prcValue === PRC_FOR_FT_EXPIRED ||
        userData.prcValue === PRC_FOR_SUBSCRIPTION_EXPIRED);
    let subsTxt = '';
    if (isSubscribed && inGracePeriod) {
      subsTxt = userIdentity?.grace?.ctaText?.replace(
        '<gracedate>',
        `${this.state.graceDate}`,
      );
    } else if (isSubscribed && isPreExpired) {
      const days =
        this.state.daysRemaining > 1
          ? `${this.state.daysRemaining} days`
          : 'Today';
      subsTxt = userIdentity?.preExpiry?.ctaText?.replace(
        '<remainingDays>',
        `${this.state.daysRemaining > 1 ? 'in' : ''} ${days}`,
      );
    } else if (isSubscribed) {
      subsTxt = userIdentity?.prc5?.ctaText?.replace('<endDate>', primeEndDate);
    } else if (isSubsExpired) {
      subsTxt = userIdentity?.prc6?.ctaText?.replace('<endDate>', primeEndDate);
    }
    const epaperArray = [
      {
        name: 'The Economic Times',
        seoName: 'the-economic-times',
        city: 'delhi',
      },
      {
        name: 'The Times Of India',
        seoName: 'the-times-of-india',
        city: 'delhi',
      },
      { name: 'Mirror', seoName: 'mirror', city: 'bangalore' },
      {
        name: 'Maharashtra Times',
        seoName: 'maharashtra-times',
        city: 'mumbai',
      },
    ];

    return (
      <span id="user-isloggedin" className={`user-isloggedin ${isPrimeUser}`}>
        <div
          className="user-controls"
          onMouseEnter={this.fireRedeemBenefitsGA4}
        >
          <div className="user-icon">
            {!this.props.isMobile &&
              this.props.toipLayout &&
              this.props.thumbImg && (
                <img src={this.props.thumbImg} alt="user icon" />
              )}
          </div>

          <span className={`user_name  ${isPrimeUser ? 'prime_user' : ''}`}>
            <div className="user-first-name">{`${this.props.firstName}`}</div>
            {isPrimeUser || isSubscribed ? <i className="plus_user" /> : null}
            {!this.props.isMobile && <i className="sprite_bg icon_down " />}
          </span>
          <div className="dropdown">
            <div className="name_details">
              <div className="user_name_dd">
                <div className="user_name_in">{this.props.firstName}</div>
                {rewardsData &&
                  rewardsData.levelName &&
                  typeof rewardsData.levelName === 'string' && (
                    <span
                      className={`points points_${rewardsData.levelName.toLowerCase()}`}
                    >
                      {rewardsData.levelName}
                    </span>
                  )}
              </div>
              {(isPrimeUser || (isSubscribed || isSubsExpired)) && (
                <React.Fragment>
                  {(isPrimeUser || isSubscribed) && (
                    <div className="toi_user_text">
                      <i /> USER
                    </div>
                  )}
                  <div className="plan_details">
                    {subsTxt}
                    {(isSubsExpired || isPreExpired) && (
                      // eslint-disable-next-line jsx-a11y/anchor-is-valid
                      <a
                        href="javascript: void(0)"
                        onClick={() => this.startPrimeRenewal()}
                      >
                        {' '}
                        Renew Now!
                      </a>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
            <ul>
              {/* {typeof rewardsData.statusPoints === 'number' &&
                rewardsData.statusPoints > 0 && (
                  <li className="tp-redeem">
                    Redeem <span>{rewardsData.statusPoints}</span>
                    <Link
                      target="_blank"
                      data-newga={
                        toipLayout
                          ? 'NavBar-User_Profile-Redeem#Section_View#WEB-Prime-AS'
                          : 'Header-User_Profile#Click-TP_Redeem-3'
                      }
                      to="https://www.timespoints.com/#/products?utm_source=TOI&amp;utm_medium=Header_Dropdown&amp;utm_campaign=TOI_HeaderDropdown"
                      rel="nofollow noreferrer noopener"
                    >
                      TimesPoints
                    </Link>
                  </li>
                )} */}

              <li>
                <Link
                  target="_blank"
                  data-newga={
                    toipLayout
                      ? 'NavBar-User_Profile-Edit_Profile#Section_View#WEB-Prime-AS'
                      : 'Header-User_Profile#Click-Edit_Profile-1'
                  }
                  to="https://jsso.indiatimes.com/sso/identity/profile/edit?channel=toi"
                >
                  Edit Profile
                </Link>
              </li>

              {/* {!(
                window.geoinfo.CountryCode === 'US' &&
                window.geoinfo.region_code === 'CA'
              ) && (
                <li>
                  <Link
                    target="_blank"
                    data-newga={
                      toipLayout
                        ? 'NavBar-User_Profile-My_Times#Section_View#WEB-Prime-AS'
                        : 'Header-User_Profile#Click-My_Times-2'
                    }
                    to="http://mytimes.indiatimes.com/?channel=toi"
                    rel="noopener nofollow noreferrer"
                  >
                    My Times
                  </Link>
                </li>
              )} */}

              <li>
                <Link target="_blank" to={MY_SUBSCRIPTION_PAGE_URL}>
                  My Subscription
                </Link>
              </li>
              <li>
                <Link
                  target="_blank"
                  to={REDEEM_BENEFITS_PAGE_URL}
                  onClick={() => {
                    analyticsWrapper('ga4', {
                      event: 'redeem_benefits',
                      steps_name: 'cta_click',
                    });
                  }}
                >
                  Redeem Benefits
                </Link>
              </li>
              <li
                className={`epaperLink ${
                  this.state.showEpaperDropDown ? 'listOpend' : ''
                }`}
                onClick={() => {
                  this.setState({
                    showEpaperDropDown: !this.state.showEpaperDropDown,
                  });
                }}
              >
                Read Other Epapers
              </li>
              {this.state.showEpaperDropDown && (
                <ul className="epaperDropdown">
                  {epaperArray.map(val => (
                    <li>
                      <Link
                        href={`https://${ET_DOMAIN_WEB}/timesepaper/publication-${
                          val.seoName
                        },city-${val.city}.cms`}
                        onClick={e => this.clickHandler(e, val)}
                      >
                        {val.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
              <li>
                <Link
                  target="_blank"
                  to={`https://${ET_DOMAIN_WEB}/epaper_preferences.cms?publication=the-times-of-india`}
                >
                  Epaper Preferences
                </Link>
              </li>

              <li
                onClick={() => {
                  if (toipLayout) {
                    gaWrapper(
                      'ga',
                      'send',
                      'event',
                      'WEB-Prime-AS',
                      'NavBar-User_Profile-Logout',
                      'Section_View',
                    );
                  }
                  this.onLogoutClick();
                }}
              >
                Logout
              </li>
            </ul>
          </div>
        </div>
      </span>
    );
  }
}

const mapStateToProps = state => ({
  userIdentity: _get(state?.translationConfig?.nudges, 'userIdentity', null),
});

LoggedInUser.propTypes = {
  firstName: PropTypes.string,
  logout: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  thumbImg: PropTypes.string,
  isPrimeUser: PropTypes.bool,
  userData: PropTypes.shape({ prcValue: PropTypes.number }),
  toipLayout: PropTypes.bool,
  userPrcData: PropTypes.shape(null),
  userIdentity: PropTypes.shape({
    prc5: PropTypes.shape({
      ctaText: PropTypes.string,
    }),
    grace: PropTypes.shape({
      ctaText: PropTypes.string,
    }),
    prc6: PropTypes.shape({
      ctaText: PropTypes.string,
    }),
    preExpiry: PropTypes.shape({
      ctaText: PropTypes.string,
    }),
  }),
  inGracePeriod: PropTypes.bool,
  isPreExpired: PropTypes.bool,
};

LoggedInUser.defaultProps = {
  firstName: '',
  isMobile: false,
  thumbImg: 'https://mytimes.indiatimes.com/image/thumb/0/default',
  isPrimeUser: false,
  userData: undefined,
  toipLayout: false,
  userPrcData: null,
  userIdentity: null,
  inGracePeriod: false,
  isPreExpired: false,
};

export default connect(mapStateToProps, null)(LoggedInUser);
